import React, {useEffect, useState} from "react";
import {useLanguageForShared} from "../../../../../../../shared/utils/languages/useLanguageForShared";
import {useTemplateFormOtherInfo} from "../data/useTemplateFormOtherInfo";
import {useParamsData} from "../data/useParamsData";
import {useEffectOnlyUpdate} from "../../../../../../../shared/utils/use_custom/useEffectCustom";
import {copyObject} from "../../../../../../../shared/utils/objUtils";
import {FormElements} from "../../../../../../../shared/bootstrap/form/FormElements";
import {useTemplateFormLOX_POC_TOC_COX} from "../data/useTemplateFormLOX_POC_TOC_COX";
import {PrescriptionTemplate} from "./PrescriptionTemplate";
import {OtherInfoTemplate} from "./OtherInfoTemplate";


export function TemplateBase({
                                 dataForm,
                                 changeValue,
                                 errors,
                                 setData,
                                 isSubmit,
                                 children
                             }) {
    const {t} = useLanguageForShared()

    const {
        formStructurePathologies,
    } = useTemplateFormLOX_POC_TOC_COX(t, dataForm);


    console.log('dataForm', dataForm)

    return (
        <>
            <FormElements
                structure={[...formStructurePathologies]}
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
            />
            <div className={'d-flex flex-column gap-4 mb-4 mt-2'}>
                {children}
            </div>
            <OtherInfoTemplate
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                setData={setData}
                isSubmit={isSubmit}
            />
        </>
    );
}
